import { useState } from "react";
import { Grid } from "@material-ui/core";

// Components
import HistoricalResultTable from "./HistoricalResultTable";
import RenameAssessmentPopover from "./RenameAssessmentPopover";
import DeleteAssessmentPopover from "./DeleteAssessmentPopover";
import AssessmentResultPopover from "./assessmentDashboard/AssessmentResultPopover";

export default function HistoricalResult({
	setError,
	setMessage,
	setLoading,
	historyResult,
	handleViewAnswers,
	setSubmissionData,
	setDataLoading,
	setSelectedAssessment,
	selectedAssessment,
	viewDialog,
	handleCloseDialogs,
	submissionData,
	initiateResult,
	setHistoryResult,
	setDashboardOpen,
}) {
	const [partialLoading, setPartialLoading] = useState(false);
	const [deleteConfirm, setDeleteConfirm] = useState(false);
	const [renameDialogOpen, setRenameDialogOpen] = useState(false);
	const [renameValue, setRenameValue] = useState("");
	const [renameSelectedItem, setRenameSelectedItem] = useState(null);

	const openRenameDialog = (item) => {
		setRenameSelectedItem(item);
		setRenameValue(item?.name || "");
		setRenameDialogOpen(true);
	};

	return (
		<Grid>
			<HistoricalResultTable
				setError={setError}
				setMessage={setMessage}
				setLoading={setLoading}
				historyResult={historyResult}
				handleViewAnswers={handleViewAnswers}
				setSubmissionData={setSubmissionData}
				setDataLoading={setDataLoading}
				setSelectedAssessment={setSelectedAssessment}
				setDashboardOpen={setDashboardOpen}
				setDeleteConfirm={setDeleteConfirm}
				partialLoading={partialLoading}
				openRenameDialog={openRenameDialog}
			/>
			<AssessmentResultPopover
				selectedAssessment={selectedAssessment}
				submissionData={submissionData}
				viewDialog={viewDialog}
				handleCloseDialogs={handleCloseDialogs}
			/>
			<DeleteAssessmentPopover
				setError={setError}
				setMessage={setMessage}
				partialLoading={partialLoading}
				setPartialLoading={setPartialLoading}
				deleteConfirm={deleteConfirm}
				setDeleteConfirm={setDeleteConfirm}
				selectedAssessment={selectedAssessment}
				initiateResult={initiateResult}
			/>
			<RenameAssessmentPopover
				partialLoading={partialLoading}
				setPartialLoading={setPartialLoading}
				initiateResult={initiateResult}
				renameDialogOpen={renameDialogOpen}
				renameSelectedItem={renameSelectedItem}
				renameValue={renameValue}
				setRenameDialogOpen={setRenameDialogOpen}
				setRenameValue={setRenameValue}
				setRenameSelectedItem={setRenameSelectedItem}
				setError={setError}
				setMessage={setMessage}
				setHistoryResult={setHistoryResult}
			/>
		</Grid>
	);
}
